export const FIELD_NAME_MODEL = {
    DEVICE_TYPE: "deviceType",
    GENDER: "gender",
    STATUS: "status",
    APPROVAL_STATUS: "approvalStatus",
    VISITOR_STATUS: "visitorStatus",
    USER_TYPE: "userType",
    CONTRACTOR_STATUS: "contractorStatus",
    SUPPLIER_STATUS: "supplierStatus",
    ENTRY_ACCESS_METHOD: "entryAccessMethod",
    EXIT_ACCESS_METHOD: "exitAccessMethod",
    ACCESS_METHOD: "accessMethod",
    IDENTITY_VALIDATION: "identityValidation",
    IDENTITY_VALIDATION_TYPE: "identityValidationType",
    FOODIE_COURSE_TYPE: "foodieCourseType",
    FOODIE_MEAL_TYPE: "foodieMealType",
}

export const getFieldNameByValue = (value) =>{
    return Object.values(FIELD_NAME_MODEL).includes(value);
}

export const ORDER_MODEL = {
    ASC: "ASC",
    DESC: "DESC"
}


export const SEARCH_OPERATION_MODEL = {
    EQ: "EQ",
    OR: "OR",
    AND: "AND",
    CN: "CN",
    BT: "BT"
}

export const DATA_TYPE_MODEL = {
    UUID: "UUID",
    LONG: "LONG",
    STRING: "STRING",
    BOOLEAN: "BOOLEAN"
}
